import React from 'react';
import { useError } from '../context/ErrorContext.tsx';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from './ui/dialog.tsx';
import { Button } from './ui/button.tsx';

const ErrorModal: React.FC = () => {
  const { globalErrorMessage, isGlobalErrorModalOpen, clearError } = useError();

  return (
    <Dialog open={isGlobalErrorModalOpen} onOpenChange={clearError}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-destructive">API Error</DialogTitle>
          <DialogDescription>
            An unexpected error occurred while communicating with the server.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 text-red-600">
          {globalErrorMessage || 'Please try again later. If the problem persists, contact support.'}
        </div>
        <DialogFooter>
          <Button onClick={clearError}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;